export const heroData = {
  title: "全网吃瓜",
  titleHighlight: "一站到底",
  subtitle: "每日更新网红爆料、黑料视频、娱乐八卦，不吃瓜你就OUT了",
  ctaPrimary: "立即吃瓜",
  ctaSecondary: "下载APP",
};

export const exclusiveScoop = {
  quote: "这瓜保熟吗？保熟！全网独家追踪，不放过任何一个塌房现场。从网红翻车到明星大瓜，51吃瓜网实时追踪，让你永远站在吃瓜第一线。",
  source: "51吃瓜编辑部",
  sourceRole: "首席吃瓜员",
  ctaLabel: "查看完整爆料",
};

export const hotGossipArticles = [
  {
    id: "1",
    slug: "wanghong-ta-fang-jingren-neimu",
    title: "某千万粉网红塌房内幕曝光，背后金主浮出水面",
    category: "网红爆料",
    imageSeq: "hot-gossip-01",
    imageQuery: "Dramatic smartphone screen showing social media scandal alert notification with red warning icon against dark blurred background, breaking news atmosphere, cinematic lighting, high contrast, editorial style with shallow depth of field, warm amber accent tones, minimalist composition, intense mood",
  },
  {
    id: "2",
    slug: "mingxing-si-liao-bei-bao-guang",
    title: "顶流明星私聊记录被曝光，内容令人大跌眼镜",
    category: "明星大瓜",
    imageSeq: "hot-gossip-02",
    imageQuery: "Close up of a smartphone displaying blurred chat messages with dramatic redacted text effect, warm ambient lighting from desk lamp, moody atmosphere, cinematic noir style, shadows and light interplay, elegant minimal composition, dark tones with warm highlights",
  },
  {
    id: "3",
    slug: "zhibo-jian-chao-jia-xian-chang",
    title: "两大主播直播间互撕现场，粉丝集体倒戈",
    category: "直播风波",
    imageSeq: "hot-gossip-03",
    imageQuery: "Split screen streaming setup with dramatic red and blue lighting contrast, gaming chair silhouettes, digital interface with live chat scrolling, intense competitive atmosphere, cinematic wide shot, editorial photography style, dark background with vibrant accent lighting",
  },
  {
    id: "4",
    slug: "meishi-bozhu-fan-cha-hei-liao",
    title: "美食博主人设崩塌，私下反差行为被扒",
    category: "网红爆料",
    imageSeq: "hot-gossip-04",
    imageQuery: "Elegant food photography flat lay with dramatic shadow casting across the scene, broken plate symbolism, warm and dark contrast lighting, cinematic still life composition, moody editorial aesthetic, rich amber and deep brown tones, mysterious atmosphere",
  },
  {
    id: "5",
    slug: "duan-shi-pin-da-shen-chao-xi",
    title: "短视频大V被指抄袭，原创作者实名举报",
    category: "抄袭实锤",
    imageSeq: "hot-gossip-05",
    imageQuery: "Two smartphones side by side showing identical content with red circles highlighting similarities, dramatic comparison lighting, editorial evidence documentation style, high contrast with warm undertones, minimal composition, intense confrontational atmosphere",
  },
  {
    id: "6",
    slug: "lian-mai-zhu-bo-nei-hong",
    title: "知名连麦主播团队内讧，合伙人连夜退出",
    category: "直播风波",
    imageSeq: "hot-gossip-06",
    imageQuery: "Empty streaming room with abandoned gaming chair and turned off ring lights, dramatic sunset light streaming through window blinds, melancholic atmosphere, cinematic interior shot, warm amber and deep shadow tones, editorial photography style, storytelling composition",
  },
];

export const appDownloadCta = {
  title: "随时随地，吃瓜不停",
  subtitle: "下载51吃瓜APP，第一时间获取最新爆料推送，离线也能看",
  buttonLabel: "下载51吃瓜APP",
};

export const navLinks = [
  { label: "首页", href: "/" },
  { label: "网红爆料", href: "/category/wanghong-baoliao" },
  { label: "明星大瓜", href: "/category/mingxing-dagua" },
  { label: "直播风波", href: "/category/zhibo-fengbo" },
  { label: "每日大赛", href: "/category/meiri-dasai" },
  { label: "关于我们", href: "/about" },
];

export const footerLinks = {
  columns: [
    {
      title: "热门分类",
      links: [
        { label: "网红爆料", href: "/category/wanghong-baoliao" },
        { label: "明星大瓜", href: "/category/mingxing-dagua" },
        { label: "直播风波", href: "/category/zhibo-fengbo" },
        { label: "每日大赛", href: "/category/meiri-dasai" },
      ],
    },
    {
      title: "快捷入口",
      links: [
        { label: "最新吃瓜", href: "/" },
        { label: "黑料视频", href: "/category/all" },
        { label: "APP下载", href: "/app" },
        { label: "关于我们", href: "/about" },
      ],
    },
    {
      title: "品牌动态",
      links: [
        { label: "品牌介绍", href: "/about" },
        { label: "加入我们", href: "/about" },
        { label: "商务合作", href: "/about" },
        { label: "帮助中心", href: "/about" },
      ],
    },
    {
      title: "法律信息",
      links: [
        { label: "使用条款", href: "/about" },
        { label: "免责声明", href: "/about" },
        { label: "隐私政策", href: "/about" },
        { label: "举报投诉", href: "/about" },
      ],
    },
  ],
  brandName: "51吃瓜网",
  brandSubtitle: "全网吃瓜一站式平台",
  copyright: "© 2026 51吃瓜网 版权所有",
};